import getContactDisplayName from "./getContactDisplayName";

const getTicketDisplayName = (ticket, currentUserId) => {
  if (!ticket) {
    return "";
  }

  if (ticket.contact) {
    return getContactDisplayName(ticket.contact);
  }

  if (ticket.isInternal) {
    if (currentUserId && ticket.internalUserId === currentUserId) {
      return ticket.user?.name || "";
    }
    return ticket.internalUser?.name || "";
  }

  return getContactDisplayName(ticket.contact);
};

export default getTicketDisplayName;